import { type TextareaProps } from "./Textarea";

interface TextareaVariantValue {
  readonly borderColor: TextareaProps["borderColor"];
  readonly bgColor: TextareaProps["bgColor"];
  readonly _focus: TextareaProps["_focus"];
}

export const textareaVariant: {
  [K in "error" | "default"]: TextareaVariantValue;
} = {
  error: {
    borderColor: "error.main",
    bgColor: "error.light",
    _focus: {
      borderColor: "error.main",
    },
  },
  default: {
    borderColor: "background.main",
    bgColor: "background.main",
    _focus: {
      borderColor: "secondary.main",
      bgColor: "light.main",
    },
  },
};

export const injectTextareaVariant = (isError: boolean | undefined): TextareaVariantValue => {
  if (typeof isError !== "undefined" && typeof isError !== "boolean") {
    throw new Error(`isError must be a boolean or undefined. isError is ${String(isError)}`);
  }
  return isError ? textareaVariant.error : textareaVariant.default;
};
